
// 时间格式化工具函数
export function tFormatDate(date, format) {
    let targetDate;
    if (date instanceof Date) {
        targetDate = date;
    } else if (typeof date === 'number') {
        targetDate = new Date(date);
    } else if (typeof date === 'string') {
        targetDate = new Date(date);
    } else {
        targetDate = new Date();
    }

    const year = targetDate.getFullYear();
    const month = String(targetDate.getMonth() + 1).padStart(2, '0');
    const day = String(targetDate.getDate()).padStart(2, '0');
    const hours = String(targetDate.getHours()).padStart(2, '0');
    const minutes = String(targetDate.getMinutes()).padStart(2, '0');
    const seconds = String(targetDate.getSeconds()).padStart(2, '0');

    return format
        .replace(/YYYY/g, year)
        .replace(/MM/g, month)
        .replace(/DD/g, day)
        .replace(/HH/g, hours)
        .replace(/mm/g, minutes)
        .replace(/ss/g, seconds);
}

